/**
 * @generated SignedSource<<2ec1cb28e0c812679d4f7119dcd2ff27>>
 * @relayHash 843b5b0f83abadddcbe41374d13f8bf5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 00f3513401c00745a818efd5b21f028112da9d14d062803d95d798b5d2194ec0

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { PlaybookLogsQuery } from './PlaybookLogsQuery.graphql';

const node: PreloadableConcreteRequest<PlaybookLogsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "00f3513401c00745a818efd5b21f028112da9d14d062803d95d798b5d2194ec0",
    "metadata": {},
    "name": "PlaybookLogsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
